module.exports = __webpack_public_path__ + "img/img55.c29b989b.jpg";